import MultipleChoiceOption from './MultipleChoiceOption';

export default class MultipleChoiceQuestion {
  constructor(data) {
    if (!data) {
      data = { };
    }

    this.is_multiple_choice = data.is_multiple_choice || false
    this.options = (data.options || []).map(x => new MultipleChoiceOption(x))
  }
}
